/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Health_UpdateInputs */

const en_us2_native_release_health_update = /** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Health Connect to connect.`)
};

const pt_br2_native_release_health_update = /** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o Health Connect para conectar.`)
};

const pt_pt2_native_release_health_update = /** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o Health Connect para conectar.`)
};

/** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */
const es_419_native_release_health_update = en_us2_native_release_health_update;

/** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */
const fr_fr2_native_release_health_update = en_us2_native_release_health_update;

/** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */
const de_de2_native_release_health_update = en_us2_native_release_health_update;

/** @type {(inputs: Native_Release_Health_UpdateInputs) => LocalizedString} */
const it_it2_native_release_health_update = en_us2_native_release_health_update;

/**
* | output |
* | --- |
* | "Update Health Connect to connect." |
*
* @param {Native_Release_Health_UpdateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_health_update = /** @type {((inputs?: Native_Release_Health_UpdateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Health_UpdateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_health_update(inputs)
	if (locale === "es-419") return es_419_native_release_health_update(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_health_update(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_health_update(inputs)
	if (locale === "de-DE") return de_de2_native_release_health_update(inputs)
	if (locale === "it-IT") return it_it2_native_release_health_update(inputs)
	return en_us2_native_release_health_update(inputs)
});
export { native_release_health_update as "native-release.health_update" }